@let isAccountPage = routerSelectors.routeNameMatchesADescendantOf('MY_ACCOUNT') | select;
@let isRegistrationPage = routerSelectors.routeNameMatches('REGISTER', 'REGISTER_EXISTING_CARD', 'REGISTER_VERIFY_EMAIL_LANDING') | select;

<px-header-top-bar/>
<px-header-logo-bar/>
@if (!isRegistrationPage) {
  <px-header-nav-bar class="hidden lg:flex"/>
  <px-account-warning-header/>
}

<div class="flex flex-row justify-start items-start flex-1 w-full" [ngClass]="{ 'gap-x-7 px-4 md:px-6 py-7': isAccountPage }">
  @if (isAccountPage && (viewportSelectors.isLgAndUp | select)) {
    <px-my-account-nav/>
  }

  <div class="@container flex flex-col self-stretch flex-1 w-full min-w-0">
    <router-outlet/>
  </div>
</div>

<px-footer/>

@if (httpLoadingSelectors.loading | select:false) {
  <mx-loading-indicator-spinner/>
}
